export default __webpack_public_path__ + "static/media/higher_icon_padlock.19009f46.svg";